module.exports = __webpack_public_path__ + "img/gentlemen-club-collection-16.baaf958d.png";